import { useTranslation } from "react-i18next";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * §4.3.1 means an unappointed ondersteuner may offer nothing, so the beschikbaarheid screen is
 * not offered at all - this stands where it would have been, and on the screen for a kept link.
 */
export function GeenBevoegdheidKaart() {
  const { t } = useTranslation("beschikbaarheid");

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("geenBevoegdheid.title")}</CardTitle>
        <CardDescription>{t("geenBevoegdheid.description")}</CardDescription>
      </CardHeader>
    </Card>
  );
}
